export default "assets/images/logo-cursive-d2d9c5fa.svg";